import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewUserPageNew from "../../components/User/ViewUserPageNew";



const ViewUserPage=() => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View User" title2="Users" link2="/user" />

        {/* AddUserLayer */}
        <ViewUserPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewUserPage;
